"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageActionCreators = exports.MessageActionTypes = void 0;
var MessageActionTypes;
(function (MessageActionTypes) {
    MessageActionTypes["Errors"] = "Message.Errors";
    MessageActionTypes["Success"] = "Message.Success";
    MessageActionTypes["Info"] = "Message.Info";
    MessageActionTypes["Warn"] = "Message.Warn";
    MessageActionTypes["Redirect"] = "Message.Redirect";
})(MessageActionTypes = exports.MessageActionTypes || (exports.MessageActionTypes = {}));
class MessageActionCreators {
}
exports.MessageActionCreators = MessageActionCreators;
MessageActionCreators.error = (errors, params) => ({
    type: MessageActionTypes.Errors,
    errors,
    params,
});
MessageActionCreators.success = (message, params, sound) => ({
    type: MessageActionTypes.Success,
    message,
    params,
    sound,
});
MessageActionCreators.info = (message, params) => ({
    type: MessageActionTypes.Info,
    message,
    params,
});
MessageActionCreators.warn = (message, params) => ({
    type: MessageActionTypes.Warn,
    message,
    params,
});
MessageActionCreators.redirect = (path) => ({
    type: MessageActionTypes.Redirect,
    path
});
//# sourceMappingURL=message.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/actions/message.js
// module id = 101
// module chunks = 0